import { useLayoutEffect, useState } from 'react';
import { cloneApi } from './module';
/* заглушки списка до ответа сервера и их проявление (только серверный режим) */
import './clone.css';

export function Clone() {
  const api = cloneApi();
  const [pane] = useState(() => api.prepare());
  useLayoutEffect(() => {
    api.attach();
  }, [api]);
  return (
    <div className="app capp">
      <div className="pane" id="pane" dangerouslySetInnerHTML={{ __html: pane }} />
    </div>
  );
}
